<template>
  <div>
    <ValidationProvider
      :rules="{ regex: /^[2-9]\d{2}[2-9]\d{2}\d{4}$/ }"
      v-slot="{ errors }"
    >
      phone number input goes here
      <input name="phone" type="text" v-model="phone" />
      <p>{{ errors[0] }}</p>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider, extend } from "vee-validate";
import { regex } from "vee-validate/dist/rules";
export default {
  components: { ValidationProvider },
  data() {
    return {
      phone: ""
    };
  }
};
</script>

<style></style>
